module.exports = __webpack_public_path__ + "static/media/5729f02e-f6b0-4f35-8ee5-c2cffa65fa76.dd23a4e9.woff";